import { createSelector } from 'reselect'

import { } from 'constants/config'
import { currencyMaker } from 'services/helpers'

import {
  CURRENCY_RATE_ZL,
  CURRENCY_RATE_CZK,
  DISPATCHER_USER_ROLE,
  ADMIN_USER_ROLE,
  PARTNER_USER_ROLE,
  LIMITED_DISPATCHER_USER_ROLE,
} from 'constants/config'

const getState = state => state.booking
const getProps = (_, props) => props
const isLoadingSelector = state => getState(state).isLoading
const bookingsSelector = state => getState(state).bookings
const websiteBookings = state => getState(state).websiteBookings
const departureBookings = state => getState(state).departureBookings
const returnBookingsSelector = state => getState(state).returnBookings

const bookingsWithoutBlacklistSelector = createSelector(
  bookingsSelector,
  bookings => bookings.filter(booking => booking.status !== 'blacklist')
)

const bookingSagaSelector = createSelector(
  bookingsSelector,
  getProps,
  (bookings, id) => bookings.find(booking => booking.id === id)
)

const ticketBookingsSelector = createSelector(
  bookingsSelector,
  returnBookingsSelector,
  (bookings, returnBookings) => {
    const filteredBookings = bookings
      .filter(({ source }) => source !== 'system' && source !== PARTNER_USER_ROLE)
    const filteredReturnBookings = returnBookings
      .filter(({ source }) => source !== 'system' && source !== PARTNER_USER_ROLE)

    return [
      ...filteredBookings,
      ...filteredReturnBookings
    ]
  }
)

const websiteBookingsSelector = createSelector(
  websiteBookings,
  bookings => bookings.filter(({ status }) => status !== 'noPaid')
)

const sourcesBookingsSelector = createSelector(
  bookingsSelector,
  (bookings) => bookings.filter(({ source }) => source === 'system')
)

const generateBookingType = (isDispatcher, currency, acc, price) => {
  const bookedType = `booked${currency}`
  const ticketType = `ticket${currency}`

  const prevBookedValue = (acc[bookedType] || 0)
  const prevTicketValue = (acc[ticketType] || 0)

  return {
    [bookedType]: isDispatcher
      ? prevBookedValue + +price
      : prevBookedValue + 0,
    [ticketType]: !isDispatcher
      ? prevTicketValue + +price
      : prevTicketValue + 0,
  }
}

const routeBookingsSummarySelector = createSelector(
  bookingsSelector,
  departureBookings,
  (bookings, departureBookings) => {
    const mergedBookings = [
      ...bookings,
      ...departureBookings
    ]

    const {
      bookedHrn = 0, ticketHrn = 0, bookedCzk = 0, ticketCzk = 0, bookedZl = 0, ticketZl = 0
    } = mergedBookings.reduce((acc, { routeType, price, source, sourceId, status }) => {
      const currency = currencyMaker(routeType, price, sourceId)

      const isDispatcher = source === DISPATCHER_USER_ROLE
        || source === LIMITED_DISPATCHER_USER_ROLE
        || source === ADMIN_USER_ROLE

      if (price && status !== 'blacklist') {
        /* eslint-disable */
        switch (currency) {
          case 'zl':
            const { bookedZl, ticketZl } = generateBookingType(isDispatcher, 'Zl', acc, price)

            acc = {
              ...acc,
              bookedZl,
              ticketZl
            }
            break
          case 'czk':
            const { bookedCzk, ticketCzk } = generateBookingType(isDispatcher, 'Czk', acc, price)

            acc = {
              ...acc,
              bookedCzk,
              ticketCzk
            }
            break
          default:
            const { bookedHrn, ticketHrn } = generateBookingType(isDispatcher, 'Hrn', acc, price)

            acc = {
              ...acc,
              bookedHrn,
              ticketHrn
            }
        }
        /* eslint-enable */
      }
      return acc
    }, {})

    const hrn = bookedHrn + ticketHrn * 0.75
    const convertedZL = (bookedZl + ticketZl * 0.75) * CURRENCY_RATE_ZL
    const convertedCZK = (bookedCzk + ticketCzk * 0.75) * CURRENCY_RATE_CZK

    return {
      bookedHrn,
      ticketHrn,
      bookedZl,
      ticketZl,
      bookedCzk,
      ticketCzk,
      summary: hrn + convertedZL + convertedCZK
    }
  }
)

export {
  bookingsSelector,
  isLoadingSelector,
  bookingSagaSelector,
  ticketBookingsSelector,
  returnBookingsSelector,
  sourcesBookingsSelector,
  websiteBookingsSelector,
  routeBookingsSummarySelector,
  bookingsWithoutBlacklistSelector
}



// WEBPACK FOOTER //
// ./src/reduxModules/selectors/BookingSelectors.js